export default function CompletionOverlay({ onDismiss }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/80" />
      <div className="relative max-w-lg p-8">
        <p className="text-white text-lg leading-relaxed font-semibold">
          This is your Nested Egg.
        </p>
        <p className="text-white/80 text-base leading-relaxed mt-4">
          You now know what your audience leaves with, the two things they must know to make that happen, the impact to make it happen, and you know what success looks like.
        </p>
        <button
          onClick={onDismiss}
          className="btn-gold mt-8 w-full text-center font-heading uppercase"
        >
          View My Nested Egg
        </button>
      </div>
    </div>
  );
}
